import api from "api"

const sessions = {
    get: (slug) => {
        return api().get(`/events/detail/${slug}/sessions`)
    },
    create: (slug, payload) => {
        return api().post(`/events/detail/${slug}/sessions`, payload);
    },
    update: (slug, id, payload) => {
        return api().put(`/events/detail/${slug}/sessions/${id}`, payload);
    },
    delete: (slug, id) => {
        return api().delete(`/events/detail/${slug}/sessions/${id}`);
    },
    uploadSpeakerPhoto: (slug, sessionId, speakerId, formData) => {
        return api().post(`/events/detail/${slug}/sessions/${sessionId}/speakers/${speakerId}/photo`, formData);
    },
    uploadImage: (slug, sessionId, formData) => {
        return api().post(`/events/detail/${slug}/sessions/${sessionId}/image`, formData);
    },
    // O que a pessoa logada já tem no evento: ingressos comprados e presenças marcadas.
    access: (slug) => {
        return api().get(`/events/detail/${slug}/schedule/access`);
    },
    // Quem já tem o ingresso do evento marca e desmarca a presença na sessão.
    markPresence: (slug, sessionId) => {
        return api().post(`/events/detail/${slug}/sessions/${sessionId}/presence`);
    },
    unmarkPresence: (slug, sessionId) => {
        return api().delete(`/events/detail/${slug}/sessions/${sessionId}/presence`);
    },
    updateLayout: (slug, layout) => {
        return api().put(`/events/detail/${slug}/layout`, { layout });
    }
}

export default sessions;
